export default __webpack_public_path__ + "static/media/QR.2a370800.svg";